import * as React from "react";
import { Sparkles, AlertCircle } from "lucide-react";
import { TrafficLightRating } from "@/modules/snapshots/businessReports.types";
import { OrderBadge } from "./components/orderBadge";
import { RagStatusBadge } from "./components/ragStatusBadge";
import { StatusBadge } from "./components/statusBadge";

interface Props {
  order: number;
  title: string;
  processing: boolean;
  isEdit: boolean;
  hasContent: boolean;
  hasEvent: boolean;
  rating: TrafficLightRating | null;
  actions?: React.ReactNode;
}

export const Header: React.FC<Props> = ({
  order,
  title,
  processing,
  isEdit,
  hasContent,
  hasEvent,
  rating,
  actions,
}) => (
  <div className="mb-3 flex items-center justify-between gap-2">
    <div className="flex min-w-0 items-center gap-3">
      <OrderBadge order={order} processing={processing} isEdit={isEdit} hasContent={hasContent} />

      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-semibold text-[#111b35]">{title}</h3>
          {hasEvent && <span className="inline-flex h-2 w-2 animate-pulse rounded-full bg-coral" title="Has event" />}
        </div>
        {processing && (
          <p className="mt-0.5 flex items-center gap-1 text-xs text-coral">
            <Sparkles className="h-3 w-3" />
            Generating content...
          </p>
        )}
        {isEdit && (
          <p className="mt-0.5 flex items-center gap-1 text-xs text-coral">
            <AlertCircle className="h-3 w-3" />
            Edit mode active
          </p>
        )}
      </div>
    </div>

    <div className="flex items-center gap-2">
      {rating && <RagStatusBadge rating={rating} />}
      <StatusBadge processing={processing} isEdit={isEdit} />
      {actions}
    </div>
  </div>
);
